module.exports = __webpack_public_path__ + "static/media/Aleo-LightItalic.715d2ef9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Aleo-LightItalic.ttf
// module id = 2818
// module chunks = 51